import React from "react";
import { Formik, Form } from "formik";
import { Grid, Paper, Typography, Stack, Button } from "@mui/material";
import { FormValues, validationSchema, initialValues } from "./types";
import { GENDERS } from "./constants";
import FormikDatePicker from "./FormikDatePicker";
import FormikTextField from "./FormikTextField";
import FormikRadioGroup from "./FormikRadioGroup";

interface UserFormProps {
  onSubmit: (values: FormValues) => Promise<void>;
}

const UserForm: React.FC<UserFormProps> = ({ onSubmit }) => (
  <Formik
    initialValues={initialValues}
    validationSchema={validationSchema}
    onSubmit={onSubmit}
  >
    {({ isSubmitting }) => (
      <Form>
        <Grid container spacing={3} marginTop={2}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              ネットビジョン社　新卒　応募フォーム
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Paper elevation={3}>
              <Stack spacing={2} padding={3}>
                <Typography variant="h6" gutterBottom>
                  基本情報
                </Typography>
                <FormikTextField
                  name="personalInfo.name"
                  label="名前"
                  fullWidth
                />
                <FormikTextField
                  name="personalInfo.name_reading"
                  label="フリガナ"
                  fullWidth
                />
                <FormikDatePicker
                  name="personalInfo.birthDate"
                  label="生年月日"
                />
		 <FormikRadioGroup
                  name="personalInfo.gender"
                  label="性別"
                  options={GENDERS}
                />
                <FormikTextField
                  name="personalInfo.school"
                  label="学校名"
                  fullWidth
                />
                <FormikTextField
                  name="personalInfo.school_major"
                  label="専攻・学部・学科"
                  fullWidth
                />
                <FormikTextField
                  name="personalInfo.school_grade"
                  label="学年"
                  fullWidth
                />
                <FormikTextField
                  name="personalInfo.address"
                  label="住所"
                  fullWidth
                />
                <Typography variant="h6" gutterBottom>
                  以下は任意です。
                </Typography>
                <FormikTextField
                  name="personalInfo.tel_no"
                  label="電話番号"
                  fullWidth
                />
                <FormikTextField
                  name="personalInfo.skill"
                  label="特技"
                  fullWidth
                />
                <FormikTextField
                  name="personalInfo.hobby"
                  label="趣味"
                  fullWidth
                />
                <FormikTextField
                  name="personalInfo.blog"
                  label="ブログ等のホームページURL"
                  fullWidth
                />
                <FormikTextField
                  name="personalInfo.games"
                  label="好きなゲームあれば"
                  fullWidth
                />
                <FormikTextField
                  name="personalInfo.animes"
                  label="好きなアニメがあれば"
                  fullWidth
                />
              </Stack>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isSubmitting}
            >
	    上の内容で応募
            </Button>
          </Grid>
        </Grid>
      </Form>
    )}
  </Formik>
);

export default UserForm;
